@defer (on timer(0.75s)) { @if (loading$ | async) {
<!-- <p-progressBar mode="indeterminate" class="loading-bar" /> -->
<ui-loading-overlay></ui-loading-overlay>
}

<p-toast [key]="DEFAULT_NOTIFICATION_SLOT_KEY" position="bottom-center"> </p-toast>

<p-toast [key]="ERROR_NOTIFICATION_SLOT_KEY" position="top-center">
  <ng-template let-message pTemplate="message">
    <span class="p-toast-message-icon" [attr.aria-hidden]="true" [attr.data-pc-section]="'icon'">
      <TimesCircleIcon [attr.aria-hidden]="true" [attr.data-pc-section]="'icon'" />
    </span>

    <div class="p-toast-message-text" [attr.data-pc-section]="'text'">
      <div class="p-toast-summary" [attr.data-pc-section]="'summary'">{{ message.summary }}</div>
      <div class="p-toast-detail" [attr.data-pc-section]="'detail'">{{ message.detail }}</div>

      <ng-container *ngIf="message.data?.explanation">
        <h5 class="mt-1 mb-0">Detail:</h5>
        <p class="mt-0" class="toast-detail">{{ message.data.explanation }}</p>
      </ng-container>
    </div>
  </ng-template>
</p-toast>
<ui-router-outlet />
<reza-ui-session-timeout-dialog></reza-ui-session-timeout-dialog>
} @placeholder {
<div class="index-wrapper">
  <div class="index-content">
    <div class="index-logo">
      <!-- <img src="./../../../assets/reza-logo2.svg" width="200" class="images logo" /> -->
    </div>
    <svg class="index-circular-loader" viewBox="25 25 50 50">
      <circle class="loader-path" cx="50" cy="50" r="20" fill="none" stroke="white" stroke-width="2" />
    </svg>

    <h2 class="index-title">načítám&hellip;</h2>
  </div>
</div>
}
